import axios from "axios";
import * as d3 from "d3";
import {responsivefy,numberFormat,axisTextDim4,colonAnnotation,tooltip_class} from '../functions';

export default function (chart, divId, vizName, filterParam) {
    console.log(vizName)
    console.log(filterParam)

// set the dimensions and margins of the graph
    var margin = chart.margin,
        width = chart.width - margin.left - margin.right,
        height = chart.height - margin.top - margin.bottom * 2;

    var svg = d3.select(divId)
    svg.selectAll("*").remove();

// append the svg object to the body of the page
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width + chart.margin.left + chart.margin.right)
        .attr("height", chart.height + chart.margin.top + chart.margin.bottom * 2)
        .call(responsivefy)
        .append("g")
        .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");

// Parse the Data
    /*var data =[
{"dim1_name":"banana","dim2_name":"Nitrogen", "metric1":12, "metric2":78},
{"dim1_name":"banana","dim2_name":"Normal", "metric1":1, "metric2":78},
{"dim1_name":"banana","dim2_name":"Stress", "metric1":13, "metric2":78},
{"dim1_name":"poacee","dim2_name":"Nitrogen", "metric1":6, "metric2":32},
{"dim1_name":"poacee","dim2_name":"Normal", "metric1":6, "metric2":32},
{"dim1_name":"poacee","dim2_name":"Stress", "metric1":33, "metric2":32},
{"dim1_name":"sorgho","dim2_name":"Nitrogen", "metric1":11, "metric2":65},
{"dim1_name":"sorgho","dim2_name":"Normal", "metric1":28, "metric2":65},
{"dim1_name":"sorgho","dim2_name":"Stress", "metric1":12, "metric2":65},
{"dim1_name":"triticum","dim2_name":"Nitrogen", "metric1":19, "metric2":55},
{"dim1_name":"triticum","dim2_name":"Normal", "metric1":6, "metric2":55},
{"dim1_name":"triticum","dim2_name":"Stress", "metric1":1, "metric2":55}
]*/
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    axios.post(url, filterParam).then(res => {

        let data = res.data;


        var result = data.reduce((x, y) => {

            (x[y.dim1_name] = x[y.dim1_name] || []).push(y);

            return x;

        }, {});


        console.log("dim1_name cate", result, result['triticum'])

        var wide = d3.nest()
            .key(function (d) {
                return d["dim1_name"]
            }) // sort by key
            .rollup(function (d) { // do this to each grouping
                // reduce takes a list and returns one value
                // in this case, the list is all the grouped elements
                // and the final value is an object with keys
                return d.reduce(function (prev, curr) {
                    prev["dim1_name"] = curr["dim1_name"];
                    prev[curr["dim2_name"]] = curr["metric1"];
                    console.log("prev", prev)
                    return prev;
                }, {});
            })
            .entries(data) // tell it what data to process
            .map(function (d) { // pull out only the values
                console.log("wides", d)
                return d.value;
            });

        // List of subgroups = header of the csv files = soil condition here
        var subgroups = [...new Set(data.map(obj => obj.dim2_name))]

        // List of groups = species here = value of the first column called dim1_name -> I show them on the X axis
        // var groups = d3.map(data, function(d){return(d.dim1_name)}).keys()
        var groups = [...new Set(data.map(obj => obj.dim1_name))]
        var lineData = []

        groups.forEach(g => {
            let sum = 0;
            result[g].forEach(r => {
                sum += r["metric1"]
                // console.log("loop r ",r,sum)
                result[g][0]['total'] = sum
            })
            lineData.push(result[g][0])
        })

        console.log("Data", data, subgroups, groups, wide, lineData)
        // Add X axis
        var x = d3.scaleBand()
            .domain(groups)
            .range([0, width])
            .padding([0.2])
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom().scale(x).tickSizeOuter(0))
            .style('font-size', "20px")
            .selectAll('text')
            .style('text-anchor', 'end')
            // .attr('dx', XaxisAttribute)
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim4);

        // Add Y axis
        var y = d3.scaleLinear()
            .domain([0, d3.max(lineData, function (d) {
                return +d.total;
            })])
            .range([height, 0]);
        svg.append("g")
            .call(d3.axisLeft(y).tickFormat(numberFormat))
            .style('font-size', "20px");

        var unique = [...new Set(data.map(item => item.metric2))];
        if (unique.length > 1) {
            // Add Y2 axis
            var y2 = d3.scaleLinear()
                .domain([d3.min(lineData, function (d) {
                    return +d.metric2;
                }), d3.max(lineData, function (d) {
                    return +d.metric2;
                })])
                .range([height, 0]);
            svg.append("g")
                .attr('transform', 'translate(' + (width) + ',0)')
                .call(d3.axisRight(y2).tickFormat(numberFormat))
                .style('font-size', "20px");
        }


        // color palette = one color per dim2_name
        /*var schemeBlue = d3.schemeBlues[9];
        var schemeBlueRem1 = schemeBlue.filter(f=> {return f!== schemeBlue[0]});
        console.log("Blue white removed",d3.schemeBlues[9],schemeBlue, schemeBlueRem1);
        var color=d3.scaleOrdinal()
            .domain(subgroups)*/
        var color = d3.scaleOrdinal()
            .domain(subgroups)
            .range(["#D1EEEE", "#9ecae1", "#6baed6", '#7ca6e7', "#4292c6", '#345bd7', "#2171b5", "#08519c", "#08306b"])
        // .range(['#c7e9b4','#7ca6e7','#7fcdbb','#41b6c4', '#4986e7','#1d91c0','#225ea8','#253494','#345bd7','#0033CC','#081d58'])
        // .range(['#0033CC', '#345bd7', '#4986e7', '#7ca6e7'])

//stack the data? --> stack per dim2_name
        var stackedGen = d3.stack()
            .keys(subgroups)
        var stackedData = stackedGen(wide)
        console.log("StackedData", stackedData)
        /*            // ----------------
        // Create a tooltip
        // ----------------
        var tooltip = d3.select(divId)
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")
            .style("background-color", "white")
            .style("border", "solid")
            .style("border-width", "1px")
            .style("border-radius", "5px")
            .style("padding", "10px")

        // Three function that change the tooltip when user hover / move / leave a cell
        var mouseover = function (d) {
            var subgroupName = d3.select(this.parentNode).datum().key;
            var subgroupValue = d.data[subgroupName];
            tooltip
                .html(chart.x2AxisDisplayName + colonAnnotation + subgroupName + "<br>" + "Value: " + subgroupValue)
                .style("opacity", 1)
        }
        var mousemove = function () {
            tooltip
                .style("left", (d3.mouse(this)[0] + 90) + "px") // It is important to put the +90: other wise the tooltip is exactly where the point is an it creates a weird effect
                .style("top", (d3.mouse(this)[1]) + "px")
        }
        var mouseleave = function () {
            tooltip
                .style("opacity", 0)
        }*/


        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip').attr('style', 'position: absolute; opacity: 0;');


        // Show the bars
        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = dim1_name per dim1_name
            .data(stackedData)
            .enter().append("g")
            .attr("fill", function (d) {
                return color(d.key);
            })
            .selectAll("rect")
            // enter a second time = loop subgroup per subgroup to add all rectangles
            .data(function (d) {
                return d;
            })
            .enter().append("rect")
            .attr("x", function (d) {
                return x(d.data.dim1_name);
            })
            .attr("y", function (d) {
                return y(d[1]);
            })
            .attr("height", function (d) {
                return y(d[0]) - y(d[1]);
            })
            .attr("width", x.bandwidth())
            .attr("stroke", "grey")
            .on("mousemove", function (d) {
                var subgroupName = d3.select(this.parentNode).datum().key;
                var subgroupValue = d.data[subgroupName];
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x2AxisDisplayName + colonAnnotation + subgroupName + "<br>" + "Value: " + subgroupValue)
                    .style("opacity", 1)
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px")
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });
        /*.on("mouseover", mouseover)
            .on("mousemove", mousemove)
            .on("mouseleave", mouseleave)*/


        // Axis Titles
        svg.append('text')
            .attr('x', (width / 3))
            .attr('y', height + 140)
            //.style('fill', 'blue')
            .style('fill', 'Black')
            .style('font-size', '40px')
            .text(chart.x1AxisDisplayName)
        // .text('dim1_name')

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - 90)
            .attr('x', 0 - (chart.height / 2) + 120)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', 'black')
            .style('font-size', '40px')
            .text(chart.y1AxisDisplayName)
        // .text('VAlue')

        // var unique = [...new Set(data.map(item => item.metric2))];
        if (unique.length > 1) {
            svg.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', width + 50)
                .attr('x', 0 - (chart.height / 2) + 120)
                .attr("dy", ".71em")
                .style("text-anchor", "end")
                .style('fill', 'black')
                .style('font-size', '40px')
                .text(chart.y2AxisDisplayName)
            // .text('metric2')

            // Draw the line
            svg
                .append("path")
                .attr("fill", "none")
                .attr("stroke", "#E3E01CFF")
                .attr("stroke-width", 1.9)
                .attr("d", function (d) {
                    console.log("line", d)
                    return d3.line()
                        .x(function (d) {
                            return x(d.dim1_name) + x.bandwidth() / 2;
                        })
                        .y(function (d) {
                            return y2(d.metric2);
                        })(lineData)


                })

            //Draw the dots for tooltip
            // Add the dots for the tooltip
            d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            var y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip' + divId.id)
                .html((d) => {
                    return chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric2)
                })

            svg.call(y1tip);

            svg.selectAll("dot")
                .data(lineData)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", d => {
                    return x(d.dim1_name) + x.bandwidth() / 2
                })
                .attr("cy", d => {
                    return y2(d.metric2)
                })
                .style("fill", "blue")
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .on("mouseover", y1tip.show)
                .on("mouseout", y1tip.hide)


        }


        var legend = svg.selectAll(".legend")
            // .data(color.domain())
            .data(color.domain().slice().reverse())
            .enter()
            .append("g")
            .attr("class", "legend")
            .attr("transform", function (d, i) {
                return "translate(0," + i * 20 + ")";
            });

        legend.append("rect")
            .attr("x", chart.width - 80)
            .attr("width", 15)
            .attr("height", 15)
            .style("fill", color);

        legend.append("text")
            .attr("x", chart.width - 50)
            .attr("y", 9)
            .attr("dy", ".3em")
            .attr("class", "legend")
            .text(function (d) {
                return d
            });

    })


}
